/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
export default {
    init() {

        //===============================
        //  ARCHIVE MOBILE FILTER PULLOUT
        //===============================

        const filterButton = document.querySelector('.filter-title--mobile');
        const filterSelectors = document.querySelector('.our-kitchens__filter-selectors');
        const filterCloseButton = document.querySelector('.kitchen-filter--mobile__close');
        const filterApplyButton = document.querySelector('.kitchen-filter__mobile-apply-button');
        const htmlTag = document.querySelector('html');
        if(filterButton){
            filterButton.addEventListener('click', () => {
                mobileOpenFilter();
            });
            filterCloseButton.addEventListener('click', () => {
                mobileCloseFilter();
            })
            filterApplyButton.addEventListener('click', () => {
                mobileCloseFilter();
            })
        }

        const mobileOpenFilter = () => {
            filterSelectors.classList.add('our-kitchens__filter-selectors--active-mobile');
            document.body.style.overflow='hidden';
            htmlTag.style.overflowY='hidden';
        }
        const mobileCloseFilter = () => {
            filterSelectors.classList.remove('our-kitchens__filter-selectors--active-mobile');
            document.body.style.overflow='auto';
            htmlTag.style.overflowY='auto';
        }


        //===============================
        //  KITCHEN ARCHIVE MOBILE FILTER
        //  CORRECT 100VH ON MOBILE BROWSERS 
        //  (ADDRESS BAR HIDES BUTTONS)
        //===============================
        // 992px for large breakpoint
    
        const mobileFilterResize = () => {
            if(window.innerWidth < 992){
                const innerHeight = window.innerHeight;
                filterSelectors.style.height = `${innerHeight}px`;
            }
            if(window.innerWidth > 992){
                
                filterSelectors.style.height = 'auto';
            }
        }

        window.addEventListener('load', mobileFilterResize);
        window.addEventListener('resize', mobileFilterResize);


        //==============================
        //  DEBOUNCE REQUESTS
        //==============================
        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }


        //===========================
        //  AJAX 
        //===========================
        //     let form = $('.sidebar-search-form')[0];//Select form
        //     var actionForm = debounce(function(e){
        //        updateQueryString();//Update query string on form change
        //        filterAction();//Submit ajax request if listed page
        //     }, 500);
        //     form.addEventListener('change', actionForm); //Listen for form changes


/*
        TODO:
        - Show spinny wheel when ajaxing
*/
        const filter = document.querySelector('#kitchen-range-filter-form');
        let loadMoreBtn = document.querySelector('#tkd-load-more');

        filter.addEventListener('change', (e) => {
            e.preventDefault();
            let formValues = getFilterValues(filter);
            updateQueryString(formValues);
            performAjaxRequest(formValues);
        });

        filter.addEventListener('reset', (e) => {
            updateQueryString('reset');
            let formValues = getFilterValues(filter);
            performAjaxRequest(formValues, 'reset');
        });


        // LOAD MORE RESULTS
        loadMoreBtn.addEventListener('click', (e) => {
            let formValues = getFilterValues(filter);
            updateQueryString(formValues);
            let tidyArr = {};
            let isFilteredSearch = false;
            Object.keys(formValues).map((key, index)=>{
                if(formValues[key].value !== '' && formValues[key].value !== undefined){
                    if(formValues[key].value !== false){
                        tidyArr[key] = formValues[key].value;
                        isFilteredSearch = true;
                    }
                }
            });
            
            $.ajax({
                url : tkd_loadmore_params.ajaxurl,
                data : {
                    'action' : 'tkd_filter_kitchens',
                    'params' : tidyArr,
                    'page' : tkd_loadmore_params.current_page,
                    'is_filtered_search' : isFilteredSearch,
                    'is_load_more' : true,
                },
                // dataType : 'json', // this data type allows us to receive objects from the server
                type : 'GET',
                beforeSend : function(xhr){
                    //TODO: show some kind of action here
                    $('#tkd-load-more').text('Loading...');
                    $('#results-wrapper').append('<div class="row append-wrapper" id="append-wrapper'+tkd_loadmore_params.current_page+'"></div>');
                    $('#append-wrapper'+tkd_loadmore_params.current_page).hide();
                    
                },
                success : function( data ){
                    var dataParsed = JSON.parse(data);
                    tkd_loadmore_params.current_page++;// when filter applied: set current page to 1
                    tkd_loadmore_params.posts = dataParsed.posts;// set the new query parameters
                    tkd_loadmore_params.max_page = dataParsed.max_page;// set the new max page parameter
                    
                    $('#tkd-load-more').text('See more kitchens');
                    //insert the posts to the container
                    // $('#results-wrapper').append(dataParsed.content);
                    $('#append-wrapper'+(tkd_loadmore_params.current_page-1)).append(dataParsed.content);
                    $('#append-wrapper'+(tkd_loadmore_params.current_page-1)).fadeIn('slow');
                    // hide load more button if there are not enough posts for the second page
                    if (  tkd_loadmore_params.current_page == tkd_loadmore_params.max_page ) { $('#tkd-load-more').hide(); } 
                    else { $('#tkd-load-more').show(); }
                },
            });
        });

        // GET ALL VALUES FROM THE FORM EXCEPT BUTTON
        function getFilterValues(form){
            let formElements = form.elements;
            let returnObj = [];
            for(let i = 0; i<formElements.length; i++){
                if(formElements[i].name !== '' && formElements[i].tagName !== 'SUBMIT'){
                    returnObj[formElements[i].name] = {
                        'value' : (formElements[i].type === 'checkbox') ? formElements[i].checked : formElements[i].value,
                    }
                }
            }

            return returnObj;
        }

        // UPDATE THE QUERY STRING TO SHOW FORM VALUES
        function updateQueryString(arr){
            if(typeof arr == 'object'){
                let arrLength = Object.keys(arr).length;
                if(arrLength > 0){
                    let tidyArr = {};
                    Object.keys(arr).map((key, index)=>{
                        if(arr[key].value !== '' && arr[key].value !== undefined){
                            tidyArr[key] = arr[key].value
                        }
                    })
                    let historyAPI = '';
                    Object.keys(tidyArr).map((key, index)=>{
                        if(tidyArr[key] !== false){
                            historyAPI += `${key}=${tidyArr[key]}&`
                        }
                    })

                    if(historyAPI.indexOf('&', historyAPI.length -1) !== -1){
                        historyAPI = historyAPI.slice(0, historyAPI.length -1);
                    }

                    if(window.location.search !== '' && window.location.search !== undefined){
                        window.history.replaceState(null, 'TKD', window.location.origin + window.location.pathname + '?'+historyAPI);
                    }else{
                        window.history.replaceState(null, 'TKD', '?'+historyAPI);
                    }
                }
            }

            // Clear any state
            if(typeof arr == 'string' && arr === 'reset'){
                window.history.replaceState(null, 'TKD', '?');
            }
        }

        // PERFORM AJAX REQUEST
        function performAjaxRequest(arr, type='default'){

            // ON RESET BUTTON CLICK, CHANGE REQUEST TYPE AND RESET RESULTS VIA AJAX 
            if(type === 'reset'){
                $.ajax({
                    url : tkd_loadmore_params.ajaxurl,
                    data : {
                        'action' : 'tkd_filter_kitchens',
                        'reset' : true,
                    },
                    type : 'GET',
                    beforeSend : function(xhr){
                        //TODO: show some kind of action here
                        $('#tkd-load-more').hide();
                        $('#results-wrapper').fadeOut('slow',);
                        $('#results-wrapper').parent().append('<div id="load-spinner" class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');

                    },
                    success : function( data ){
                        var dataParsed = JSON.parse(data);
                        tkd_loadmore_params.current_page = 1; // reset to page 1
                        tkd_loadmore_params.posts = dataParsed.posts; // set the new query parameters
                        tkd_loadmore_params.max_page = dataParsed.max_page; // set the new max page parameter
                
                        //insert the posts to the container
                        $('#load-spinner').remove();
                        $('#results-wrapper').html('');
                        $('#results-wrapper').append(dataParsed.content);
                        $('#results-wrapper').fadeIn('slow');
                
                        // hide load more button if there are not enough posts for the second page
                        if ( dataParsed.max_page < 2 ) { $('#tkd-load-more').hide(); } 
                        else { $('#tkd-load-more').show(); }
                    },
                });
            }

            // REGULAR REQUEST - FORM FIELDS ARE PASSES TO AJAX REQUEST, CLEANING CONTAINER AND REPOPULATING WITH RESULTS
            if(type !== 'reset' && typeof arr == 'object'){
                let arrLength = Object.keys(arr).length;
                if(arrLength > 0){
                    let tidyArr = {};
                    let isFilteredSearch = false;
                    Object.keys(arr).map((key, index)=>{
                        if(arr[key].value !== '' && arr[key].value !== undefined){
                            if(arr[key].value !== false){
                                tidyArr[key] = arr[key].value;
                                isFilteredSearch = true;
                            }
                        }
                    });

                    $.ajax({
                        url : tkd_loadmore_params.ajaxurl,
                        data : {
                            'action' : 'tkd_filter_kitchens',
                            'params' : tidyArr,
                            'is_filtered_search' : isFilteredSearch,
                        },
                        // dataType : 'json', // this data type allows us to receive objects from the server
                        type : 'GET',
                        beforeSend : function(xhr){
                            //TODO: show some kind of action here
                            $('#tkd-load-more').hide();
                            $('#results-wrapper').fadeOut('slow',);
                            $('#results-wrapper').parent().append('<div id="load-spinner" class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
                            // $('#tkd-load-more').text('Loading...');
                        },
                        success : function( data ){
                            var dataParsed = JSON.parse(data);
                            tkd_loadmore_params.current_page = 1;// when filter applied: set current page to 1
                            tkd_loadmore_params.posts = dataParsed.posts;// set the new query parameters
                            tkd_loadmore_params.max_page = dataParsed.max_page;// set the new max page parameter

                            //insert the posts to the container
                            $('#tkd-load-more').text('See more kitchens');
                            $('#load-spinner').remove();
                            $('#results-wrapper').html('');
                            $('#results-wrapper').append(dataParsed.content);
                            $('#results-wrapper').fadeIn('slow');
                    
                            // hide load more button if there are not enough posts for the second page
                            if ( dataParsed.max_page < 2 ) {
                                $('#tkd-load-more').hide();
                            } else {
                                $('#tkd-load-more').show();
                            }
                        },
                    });
                }
            }
        }


        

    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS

        
    },
  };
  